// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-card[data-v-b9d39bba]{margin-top:25px;width:1200px;margin:0 auto}.applyInfoPage[data-v-b9d39bba]{margin-top:50px;height:calc(100vh - 400px)}.applyInfoPage .notice[data-v-b9d39bba]{padding:24px}.applyInfoPage .notice p[data-v-b9d39bba]{padding:10px 0}", ""]);
// Exports
module.exports = exports;
